//export const API_BASE_URL = "http://localhost:8000";
//export const API_BASE_URL = "http://0.0.0.0:8000";
export const API_BASE_URL = "https://presentation-skill.gallerylambda.com";
export const API_SIGN_UP_PATH = "/api/dj-rest-auth/registration/";
export const API_TOKEN_PATH = "/api/token/";
export const API_REFRESH_PATH = "/api/token/refresh/"
export const API_PERMISSION_REQUIRED_TEST_PATH = "/api/"
export const API_USERNAME_PATH = "/api/auth/username/"
export const API_VOTE_PATH = "/api/community/create-user-vote/"
export const API_SUGGEST_PATH = "/api/community/suggest-choice-by-category/"
export const API_GET_CHOICES_PATH = "/api/community/get-choices-by-category/"
export const API_GET_VOTE_PATH = "/api/community/get-upvote-by-choice/"
export const API_GET_USER_PROFILE = "/api/auth/get-user-profile/"
export const API_DELETE_USER_PROFILE = "/api/auth/get-delete-user-profile/"
export const API_LOGOUT = "/api/auth/logout/"
export const UI_SIGN_IN_PATH = "/sign-in/"
export const UI_BOOK1 = "/book1/"
export const UI_COFFEE_BREAK = "/coffee-break/"
export const UI_BOOK2 = "/book2/"
export const UI_CREDIT_CARD = "/credit-card/"
export const UI_HER = "/her/"
export const UI_EC = "/ec/"
export const UI_MOBILE_CARRIER = "/mobile-carrier/"
export const UI_FURNITURE_AND_ELECTRONICS = "/year-and-ear/"
export const UI_OTHERS = "/final-step/"
export const UI_SELF_SERVICE = "/account/"
export const TIME_DELAY_MSEC = 3000
export const API_SCORE_HER_VOICE_PATH = "/api/v1/inference/score_her_voice/"
export const API_GET_HER_STATS = "/api/v1/inference/her_stats/"
export const RECORD_SAMPLING_RATE = 22050 // if smaller, lower transmit but heavy calc at server side
export const VOLUME_THRESHOLD = 0.002

// biz-professional-frontend specific
export const UI_BASE_URL = "https://presentation-skill.gallerylambda.com";
export const UI_ISSUE = "/issue-analysis"
export const UI_SLIDE_STRUCTURE = "/slide-structure"
export const UI_TOP_MESSAGE = "/top-message"
export const UI_DESIGN = "/design"
export const UI_BOTTOM = "/bottom-message"
export const UI_SUMMARY = "/executive-summary"
export const UI_PRESENTATIONS = "/consulting-presentations"
export const UI_PROFESSIONAL_BOOKS = "/professional-books"
export const UI_EPILOGUE = "/epilogue"
export const GA_ID = "G-MCH962VN8J"
